import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Permission } from 'types/Permission'
import { BulkItemProps } from '.'
import Button from '@/ui/Button'
import { usePermissionCheck } from '@/hooks'
import { InnerWrapper, OuterWrapper } from './Styles'
import { ReactComponent as ChevronRight } from '@/assets/images/icons/chevron-right.svg'

interface ButtonWithChildItemsProps {
  content: string
  icon: React.ReactNode
  closeParent: () => void
  requiredRoles?: Permission[]
  childItems: BulkItemProps[]
}

const ButtonWithChildItems = ({
  content,
  icon,
  closeParent,
  childItems,
}: ButtonWithChildItemsProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const [topOffset, setTopOffset] = useState(0)
  const { hasPermissions } = usePermissionCheck()
  const { t } = useTranslation()
  return (
    <div
      onMouseLeave={() => {
        if (isOpen) {
          setIsOpen(false)
        }
      }}
      onMouseOver={e => {
        if (!isOpen) {
          const target = e.target as HTMLElement
          const offset = target.offsetTop
          const height = target.offsetHeight
          setTopOffset(offset + height / 2)
          setIsOpen(true)
        }
      }}>
      <Button
        variant="outlined"
        key={`${content}-${icon}`}
        content={content}
        rightIcon={<ChevronRight style={{ marginLeft: 'auto' }} />}
        leftIcon={icon}
      />
      {isOpen && (
        <OuterWrapper style={{ top: topOffset + 'px' }}>
          <InnerWrapper>
            <Button.Group packTightly vertical>
              {childItems.map(
                ({
                  content,
                  requiredRoles,
                  disabled,
                  disabledReason,
                  onClick,
                }) => {
                  const renderedDisabledReason = !hasPermissions(requiredRoles)
                    ? t('You do not have permission to perform this action')
                    : disabledReason
                  return (
                    <Button
                      key={`${content}-${icon}`}
                      variant="outlined"
                      disabled={disabled || !hasPermissions(requiredRoles)}
                      disabledReason={renderedDisabledReason}
                      content={content}
                      onClick={() => {
                        onClick()
                        closeParent()
                      }}
                    />
                  )
                },
              )}
            </Button.Group>
          </InnerWrapper>
        </OuterWrapper>
      )}
    </div>
  )
}

export default ButtonWithChildItems
